import type { ModelManifest } from "../types";

const modelManifest: ModelManifest = {
  "version": 2,
  "runtime": "onnx",
  "modelUrl": "https://transkun-assets.chord.tube/models/transkun-web.268a9d6a30086821.onnx",
  "metadataUrl": "https://transkun-assets.chord.tube/models/transkun-web-metadata.5e9aa98a6866eff0.json",
  "providers": [
    "webgpu",
    "wasm"
  ],
  "ort": {
    "webgpuPaths": {
      "wasm": "https://transkun-assets.chord.tube/runtime/ort/ort-wasm-simd-threaded.asyncify.7e83cd6cee77e478.wasm",
      "mjs": "https://transkun-assets.chord.tube/runtime/ort/ort-wasm-simd-threaded.asyncify.7236653b8565da40.mjs"
    },
    "wasmFallbackPaths": {
      "wasm": "https://transkun-assets.chord.tube/runtime/ort/ort-wasm-simd-threaded.d1ab1b94b16a65b2.wasm",
      "mjs": "https://transkun-assets.chord.tube/runtime/ort/ort-wasm-simd-threaded.0a1e718d99c41b22.mjs"
    }
  },
  "ffmpeg": {
    "multiThread": {
      "coreURL": "https://transkun-assets.chord.tube/runtime/ffmpeg-mt/ffmpeg-core.270a2e6ff945e173.js",
      "wasmURL": "https://transkun-assets.chord.tube/runtime/ffmpeg-mt/ffmpeg-core.be2c97605366b78f.wasm",
      "workerURL": "https://transkun-assets.chord.tube/runtime/ffmpeg-mt/ffmpeg-core.worker.f77898d631dc010b.js"
    },
    "singleThread": {
      "coreURL": "https://transkun-assets.chord.tube/runtime/ffmpeg/ffmpeg-core.67a48f11645f8543.js",
      "wasmURL": "https://transkun-assets.chord.tube/runtime/ffmpeg/ffmpeg-core.9f57947a5bd530d8.wasm"
    }
  }
};

export default modelManifest;
